<template>
    <b-modal
        :title="$t(id ? 'Update Serial Number' : 'Add Serial Number')"
        :visible="value"
        @close="$emit('input', false)"
        @shown="loadEditor"
        :id="'modal-edit-base-product-' + id"
        size="lg"
        no-close-on-backdrop
        :ok-title="$t('save')"
        @ok="save"
        :ok-disabled="saving"
        @cancel="$emit('input', false)"
    >
        <loading-spinner class="loading-spinner" v-if="loading" />
        <b-form v-else @submit="save" :disabled="saving">
            <b-form-group
                id="fieldset-serial_number"
                :label="$t('Serial Number')"
                label-for="input-1"
                :invalid-feedback="errors['serial_number']"
                :state="getFieldState('serial_number')"
            >
                <b-form-input
                    required
                    :state="getFieldState('serial_number')"
                    v-model="serial_number"
                    :placeholder="$t('Serial Number')"
                ></b-form-input>
            </b-form-group>
            <b-form-group
                id="fieldset-reference"
                :label="$t('product_variant_reference')"
                label-for="input-2"
                :invalid-feedback="errors['reference']"
                :state="getFieldState('reference')"
            >
                <b-form-select v-model="reference">
                    <b-form-select-option :value="null"
                        >{{ $t("product_variant_reference") }}
                    </b-form-select-option>
                    <b-form-select-option
                        v-for="v in variants"
                        :key="v.id"
                        :value="v.reference"
                    >
                        {{
                            v.name !== ""
                                ? `${v.reference} - ${v.name}`
                                : v.reference
                        }}
                    </b-form-select-option>
                </b-form-select>
                <!--                <b-form-input-->
                <!--                    required-->
                <!--                    :state="getFieldState('reference')"-->
                <!--                    v-model="reference"-->
                <!--                    :placeholder="$t('product_variant_reference_placeholder')"-->
                <!--                ></b-form-input>-->
            </b-form-group>
        </b-form>
    </b-modal>
</template>

<script>
import axios from "axios";
import LoadingSpinner from "../../Common/LoadingSpinner";

export default {
  name: "SerialNumberDialog",
  components: { LoadingSpinner },
  props: {
    id: Number,
    value: Boolean,
    base_product_id: Number,
    variants: Array
  },
  data() {
    return {
      base_product: null,
      serial_number: null,
      reference: null,
      errors: {},
      saving: false,
      loading: true
    };
  },
  mounted() {
    this.reference = null;
  },
  methods: {
    getFieldState(field) {
      return this.errors[field] === undefined ? null : false;
    },
    save(bvModalEvent) {
      bvModalEvent.preventDefault();
      this.saving = true;
      this.errors = {};
      let rp = this.id ? this.update() : this.create();
      rp.then(r => {
        this.$emit("input", false);
        this.$emit("saved", true);
      })
        .catch(err => {
          for (let [key, value] of Object.entries(err.response.data.errors)) {
            this.$set(this.errors, key, value[0]);
          }
        })
        .finally(() => {
          this.saving = false;
        });
    },
    create() {
      return axios
        .post(`/api/product-instances`, this.getData())
        .then(response => {
          this.$emit("instance-changed", {
            type: "create",
            model: response.data.data
          });

          this.reference = null;
          this.serial_number = null;
        });
    },
    update() {
      return axios
        .put(`/api/product-instances/${this.id}`, this.getData())
        .then(response => {
          this.$emit("instance-changed", {
            type: "update",
            model: response.data.data
          });

          this.reference = null;
          this.serial_number = null;
        });
    },
    getData() {
      return {
        serial_number: this.serial_number,
        base_product_id: this.base_product_id,
        reference: this.reference
      };
    },
    loadEditor() {
      this.errors = {};
      if (this.id) {
        this.getProductInstance();
      } else {
        this.loading = false;
      }
    },
    getProductInstance() {
      axios.get(`/api/product-instances/${this.id}`).then(r => {
        let data = r.data.data;
        this.serial_number = data.serial_number;
        this.reference = data.reference;

        this.loading = false;
      });
    }
  }
};
</script>

<style scoped>
</style>
